// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import {userReducer as user} from '@modules/user/'
import {appReducer as app} from './app'
import navbar from './navbar'
import layout from './layout'

const basicReducers = {
  app,
  user,
  navbar,
  layout
}

export default basicReducers
